import { Expose } from 'class-transformer';

import { Default } from '@lib/common/decorators';
import { SnModel } from '@lib/common/models';

export class ApplianceStatus extends SnModel {
  @Expose()
  @Default(0)
  public countDownLocalAppliances: number;

  @Expose()
  @Default(0)
  public countLocalAppliances: number;

  @Expose()
  @Default(0)
  public countPendingLocalAppliances: number;

  @Expose()
  @Default(0)
  public countTotalAppliances: number;

  @Expose()
  @Default(0)
  public countUpLocalAppliances: number;

  @Expose()
  @Default(0)
  public countTotalCameras: number;

  @Expose()
  @Default(0)
  public countManagedCameras: number;

  @Expose()
  @Default(0)
  public countUnmangedCameras: number;

  @Expose()
  @Default(0)
  public countConfiguredCameras: number;

  @Expose()
  @Default(0)
  public countUnconfiguredCameras: number;

  @Expose()
  @Default(0)
  public countExternalCameras: number;

  @Expose()
  @Default(0)
  public countRecordingEnabledCameras: number;

  @Expose()
  @Default(0)
  public countTranscodedCameras: number;

  @Expose()
  @Default(0)
  public countAiEnabledCameras: number;

  constructor(data: any) {
    super();
    this.fromJSON(data);
  }
}
